import { createAction } from '../util/index.js';

export const toggleVideoModal = createAction(
    'TOGGLE_VIDEO_MODAL',
    requestObject => requestObject
);